import React from "react";
import s from "../styles/signup.module.css";
import BlCard from "../components/SignUpCard";
import blwoman from "../assets/images/blwoman.png";
import googleicon from "../assets/icons/googleicon.svg";
import line from "../assets/svgs/line.svg";
import Wave from "../assets/svgs/handemoji.svg";
import { useFormik } from "formik";
import * as yup from "yup";
import caution from "../assets/svgs/caution.svg";

// onChange, onBlur,touched, onSubmit, errors, value, isSubmitting
const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&]).{8,}$/;

const nameRules1 = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/;

const nameRules2 = /^\s*[\S]+(\s[\S]+)+\s*$/;

const phoneNumRules =
/^((\+)(234){1}[0-9]{10})|((234)[0-9]{10})|((0)(7|8|9){1}(0|1){1}[0-9]{8})$/;

const onSubmit = async (values, actions) => {
  await new Promise((resolve) => setTimeout(resolve, 1000));
  actions.resetForm();
};

const FormSchema = yup.object().shape({
  fullName: yup
    .string()
    .matches(nameRules1, { message: "Name can only contain latin letters" })
    .matches(nameRules2, { message: "Please enter your full name" })
    .required("Required"),
  email: yup.string().email("Please enter a valid email").required("Required"),
  password: yup
    .string()
    .min(8)
    .matches(passwordRules, { message: "Please create a stronger password" })
    .required("Required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Required"),

  pNumber: yup
    .string()
    .matches(phoneNumRules, { message: "Please enter a valid number" })
    .required("Required"),
});

const Signup = () => {
  const {
    handleChange,
    handleBlur,
    touched,
    handleSubmit,
    errors,
    values,
    isSubmitting,
  } = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: FormSchema,
    onSubmit,
  });
  console.log(values);

  return (
    <div className={s.wrapper}>
      <BlCard image={blwoman} />

      <div className={s.container}>
        <div className={s.Login}>
          <div className={s.Welcome}>
            <div className={s.head}>Welcome</div>
            <img src={Wave} alt="hand waving emoji" className={s.wave} />
          </div>
          <div className={s.book}>
            <p className={s.choice}>
              You can book any bus to any destination of your <br></br>choice.
            </p>
          </div>
          <div className={s.login}>
            <button className={s.btn}>
              <img src={googleicon} className={s.gicon} alt="google icon" />
              Register with Google
            </button>

            <div className={s.or}>
              <img src={line} alt="decorative line" className={s.line} />
              <p className={s.orText}>or</p>
              <img src={line} alt="decorative line" className={s.line} />
            </div>

            <form action="">
              <label htmlFor="" className={s.lbl}>
                FullName
              </label>
              <input
                type="text"
                name="fullName"
                id="fullName"
                placeholder="e.g Juda Osai"
                value={values.fullName}
                onChange={handleChange}
                onBlur={handleBlur}
                className={errors.fullName && touched.fullName ? s.input : ""}
              />
              {errors.fullName && touched.fullName && (
                <p className={s.error}>
                  <img src={caution} alt="" className={s.caution} />
                  {errors.fullName}
                </p>
              )}

              <label htmlFor="" className={s.lbl}>
                Email Address
              </label>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="e.g judaosai@gmail.com"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                className={errors.email && touched.email ? s.input : ""}
              />

              {errors.email && touched.email && (
                <p className={s.error}>
                  <img src={caution} alt="" className={s.caution} />
                  {errors.email}
                </p>
              )}

              <label htmlFor="" className={s.lbl}>
                Phone Number
              </label>
              <input
                type="text"
                name="pNumber"
                id="pNumber"
                placeholder="e.g 08090000000"
                value={values.phoneNumber}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.pNumber && touched.pNumber && (
                <p className={s.error}>
                  <img src={caution} alt="" className={s.caution} />
                  {errors.pNumber}
                </p>
              )}

              <label htmlFor="" className={s.lbl}>
                Password
              </label>
              <input
                type="password"
                name="password"
                id="password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                className={errors.password && touched.password ? s.input : ""}
              />
              {errors.password && touched.password && (
                <p className={s.error}>
                  <img src={caution} alt="" className={s.caution} />
                  {errors.password}
                </p>
              )}

              <label htmlFor="" className={s.lbl}>
                Confirm Password
              </label>
              <input
                type="password"
                name="confirmPassword"
                id="confirmPassword"
                value={values.confirmPassword}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  errors.confirmPassword && touched.confirmPassword
                    ? s.input
                    : ""
                }
              />

              {errors.confirmPassword && touched.confirmPassword && (
                <p className={s.error}>
                  <img src={caution} alt="" className={s.caution} />
                  {errors.confirmPassword}
                </p>
              )}
              <div className={s.checkWrapper}>
                <input
                  type="checkbox"
                  name="TAC"
                  id="checkbox"
                  className={s.chk}
                />

                <label className={s.check}>
                  I agree to the{" "}
                  <span className={s.tos}>
                    {" "}
                    <a>Terms & Conditions</a>
                  </span>{" "}
                  and{" "}
                  <span className={s.tos}>
                    <a>Privacy Policy</a>
                  </span>
                </label>
              </div>
              <button className={s.btn2}>Register</button>
            </form>
            <p id={s.noAccount}>
              Already have an account?{" "}
              <span>
                <a href="/Login">Login</a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
